import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EditPlanningComponent} from './edit-plannning/edit-planning.component';
import {DuplicateDayComponent} from './duplicate-day/duplicate-day.component';
import {EditDayScheduleItemComponent} from './edit-day-schedule-item/edit-day-schedule-item.component';
import {EditDayScheduleComponent} from './edit-day-schedule/edit-day-schedule.component';
import {ButtonsModule} from './buttons/buttons.module';
import {MwFormsModule} from './forms/forms.module';
import {SharedModule} from '../shared.module';
import {DirectivesModule} from '../directives/directives.module';
import {MatListModule} from '@angular/material/list';
import {PipesModule} from '../pipes/pipes.module';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRippleModule} from '@angular/material/core';
import {ImagesModule} from './images/images.module';
import {MatButtonModule} from '@angular/material/button';
import {PlaylistFolderDisplayComponent} from './playlist-folder-display/playlist-folder-display.component';
import {SchedulerModifierHeaderComponent} from './scheduler-modifier-header/scheduler-modifier-header.component';
import {BreadcrumbModule} from './breadcrumb/breadcrumb.module';


@NgModule({
  declarations: [
    EditPlanningComponent,
    DuplicateDayComponent,
    EditDayScheduleItemComponent,
    EditDayScheduleComponent,
    PlaylistFolderDisplayComponent,
    SchedulerModifierHeaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DirectivesModule,
    MatListModule,
    PipesModule,
    MatIconModule,
    MwFormsModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    ImagesModule,
    ButtonsModule,
    MatButtonModule,
    BreadcrumbModule
  ], exports: [
    EditPlanningComponent,
    DuplicateDayComponent,
    EditDayScheduleItemComponent,
    EditDayScheduleComponent,
    PlaylistFolderDisplayComponent,
    SchedulerModifierHeaderComponent
  ]
})
export class ComponentsModule {
}
